import VacancyBeforePublishPreview from './VacancyBeforePublishPreview.page';

export default VacancyBeforePublishPreview;
